import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'whatsapp' | 'ghost';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  templateUrl: './app-button.html',
  styleUrl: './app-button.scss',
})
export class AppButton {
  variant = input<ButtonVariant>('primary');
  loading = input<boolean>(false);
  disabled = input<boolean>(false);

  pressed = output<MouseEvent>();

  readonly variantClasses = computed(() => {
    switch (this.variant()) {
      case 'primary':
        return 'bg-[#141B35] border-[#141B35] w-full text-white border border-color-[#141B35]';
      case 'secondary':
        return 'bg-white text-[#e11319] hover:bg-[#e11319] hover:text-white border-[#e11319] w-full border border-color-[#e11319]';
      case 'whatsapp':
        return 'bg-white text-[#131C35] border border-[#131C35] hover:bg-[#131C35] hover:text-white w-full';
      case 'ghost':
        return 'bg-transparent text-[#A1A7B8] hover:text-[#141B35] border-transparent shadow-none w-auto px-0 py-0';
      default:
        return '';
    }
  });

  handleClick(event: MouseEvent) {
    if (this.loading() || this.disabled()) {
      event.preventDefault();
      return;
    }

    this.pressed.emit(event);
  }
}
